import { isUserLoggedIn } from "@/auth/utils";

export default [
    {
        path: "/apps",
        name: "apps",
        component: () => import("@/views/modules/apps/apps.vue"),
        meta: {
            contentClass: "module-apps",
            resource: "apps",
            action: "update",
        },
        beforeEnter: isUserLoggedIn,
    },
    {
        path: "/apps/:appName",
        name: "apps-open",
        component: () => import("@/views/modules/apps/appSettings.vue"),
        meta: {
            contentClass: "module-apps",
            resource: "apps",
            action: "update",
        },
        beforeEnter: isUserLoggedIn,
    },
];
